<template>
  <v-navigation-drawer v-model="drawerMenu" location="left" temporary class="menu-drawer" v-on:update:modelValue="recolher">
    <v-row class="px-4 ma-0">
      <v-col cols="12" class="px-0 py-3 d-flex align-center justify-start">
        <v-btn variant="outlined" rounded="xl" class="text-color-0" @click="recolher">
          <template v-slot:prepend>
            <v-icon icon="mdi-chevron-left" class="text-color-2"></v-icon>
          </template>
          RECOLHER
        </v-btn>
      </v-col>
      <!-- <v-col class="pa-0 d-flex align-center justify-end">
        <v-skeleton-loader :loading="logoImage == null" width="80" class="logo-supermercado-small">
          <v-img v-if="logoImage != 'no-image'" :src="logoImage" class="cursor-pointer" alt="Logo"></v-img>
          <v-img v-else src="@/assets/images/logo-supermercado.png" class="cursor-pointer" alt="Logo"></v-img>
        </v-skeleton-loader>
      </v-col> -->
    </v-row>
    <v-row class="ma-0">
      <v-col cols="12" class="pa-0">
        <hr class="fine-line">
      </v-col>
    </v-row>
    <v-row class="ma-0" v-if="storeImage != null">
      <v-col class="pa-0">
        <v-img v-if="storeImage != 'no-image'" :src="storeImage" alt="Store"></v-img>
      </v-col>
    </v-row>
    <v-row class="pa-4 ma-0 bg-green" v-if="getIsu > 0">
      <v-col cols="8" class="pa-0 pe-2 d-flex align-center justify-center">
        <span class="text-small">Veja quanto você já economizou utilizando nosso aplicativo.</span>
      </v-col>
      <v-col cols="4" class="pa-0 d-flex align-center justify-end">
        <div class="poupometro rounded">
          <v-skeleton-loader :loading="loadingPoupometro" type="text" class="bg-color-transparent">
            {{ $formatNumber(getPoupometro, {style: 'currency', currency: 'BRL'}) }}
          </v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
    <v-row class="ma-0">
      <v-col class="pa-0">
        <v-list class="w-100 px-0 py-2">
          <v-list-item append-icon="mdi-chevron-right" class="link-menu cy-menu-folhetos" @click="$router.push('/services/folhetos')">
            <div class="d-flex align-center">
              <Svgs :icon="'folheto'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Folhetos</span>
            </div>
          </v-list-item>
          <v-list-item append-icon="mdi-chevron-right" class="link-menu cy-menu-lembretes" @click="$router.push('/services/lembretes')">
            <div class="d-flex align-center">
              <Svgs :icon="'lembrete'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Lembretes</span>
            </div>
          </v-list-item>
          <v-list-item append-icon="mdi-chevron-right" class="link-menu cy-menu-premios" @click="$router.push('/services/premios')">
            <div class="d-flex align-center">
              <Svgs :icon="'premios'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Prêmios e Brindes</span>
            </div>
          </v-list-item>
          <v-list-item v-if="checkModules(9) == 9" append-icon="mdi-chevron-right" class="link-menu cy-menu-pontos" @click="$router.push('/services/pontos')">
            <div class="d-flex align-center">
              <Svgs :icon="'foguete'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Programa de Pontos</span>
            </div>
          </v-list-item>
          <v-list-item v-if="checkModules(8) == 8" append-icon="mdi-chevron-right" class="link-menu cy-menu-carteira" @click="$router.push('/services/carteira')">
            <div class="d-flex align-center">
              <Svgs :icon="'carteira'" :color="'fill-color-2'" :width="30" :height="30"></Svgs> <span class="ms-3">Carteira Digital</span>
            </div>
          </v-list-item>
        </v-list>
        <v-list class="w-100 pa-0 br-0">
          <v-list-item prepend-icon="mdi-menu" class="bg-color-2 text-white">Departamentos</v-list-item>
          <v-list-item v-for="t in getCategoriesLimit()" v-bind:key="t.id" append-icon="mdi-chevron-right" class="link-menu" @click="$router.push('/feed/'+t.id)">{{ capitalize(t.name) }}</v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Svgs from '@/components/Svgs.vue';
import { capitalize } from '@/store/services/utils.js';
export default {
  name: 'Menu',
  components: {
    Svgs
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
      required: true
    },
    recolher: {
      type: Function,
      default: null,
      required: true
    }
  },
  data(){
    return {
      drawerMenu: false
    }
  },
  computed: {
    ...mapGetters('main', {
      getCategoriesLimit: 'getCategoriesLimit',
      getPoupometro: 'getPoupometro',
      checkModules: 'checkModules'
    }),
    ...mapGetters('user', {
      getIsu: 'getIsu'
    }),
    ...mapState('main', {
      loadingPoupometro: 'loadingPoupometro',
      logoImage: 'logoImage',
      storeImage: 'storeImage'
    }),
  },
  watch: {
    drawer() {
      this.drawerMenu = this.drawer;
      if(this.drawer == true){
        this.savedValue();
      }
    }
  },
  methods: {
    ...mapActions('main', {
      savedValue: 'savedValue'
    }),
    capitalize,
    keyDownHandler: function(event) {
      if (event.code === 'Escape') {
        this.recolher();
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyDownHandler);
  },
  unmounted () {
    window.removeEventListener('keydown', this.keyDownHandler);
  },
}
</script>